// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609281558/js/" + chunkId + "." + {"44":"e82b5fe2","225":"fb623952","481":"09ead294","486":"cf1cd821","770":"2380b0ec"}[chunkId] + ".0.7453612533335574.chunk.js";
};